// removed by extract-text-webpack-plugin
module.exports = {"introduction-area":"introduction-area__gLlv8","description":"description__3SoNJ","list":"list__38bdO"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleDetail/styles/IntroductionArea.scss
// module id = MRTi
// module chunks = 1